import React, { useCallback } from 'react';

import { t } from 'i18next';

import BdsLabelPill from '../../../../../shared/components/v3/BdsActivityPill/BdsActivityPill';
import { ICompanyPlanAddon } from '../../../../../shared/interfaces/plans';
import { TRANSLATION_MANAGE_COLLABORATORS } from '../../../../../shared/translations/manageCollaborators';

interface IPlanAddons {
  planAddons?: ICompanyPlanAddon[];
}
const PlanAddons = ({ planAddons }: IPlanAddons) => {
  const separator = ' • ';

  const addons = useCallback(() => {
    if (!planAddons || planAddons.length === 0) return '';

    const benefitsMessage = t(TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.addons, {
      benefits: planAddons.length
    });

    if ((planAddons.length >= 2 && planAddons.some((addon) => addon.name.length > 7)) || planAddons.length >= 3) {
      return benefitsMessage;
    }

    return planAddons.map((addon) => addon.name).join(separator);
  }, [planAddons]);

  const renderActivityPills = () => {
    if (planAddons && planAddons.length > 0) {
      return <BdsLabelPill label={addons()} variant={'inverse'} />;
    } else {
      return null;
    }
  };

  return renderActivityPills();
};

export default PlanAddons;
